module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/anLin1/tc-custom/1.png?1685203880310?1705540911253",
      "alt": "This image is the cover for the book A Thing or Two About Fruit"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Thing or Two About Fruit\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A blood-red orb cured a demon of her baby-eating habit and she became the protector of little children; fuzzy fruits replaced humans in sacrifices to their gods but embalmed their dead; a notorious beauty of Napoleon’s court bathed in twenty-two pounds of a berry that blushed the cheeks of noblewomen after their bloodlettings. In A Thing or Two About Fruit, Rodman offers a glimpse of humans’ faith and folly around their fruits and invites you to determine which of the many contenders was the true Fruit of Temptation. The beautiful photographs, from flowers to fruition, bring fruits to life and enhance their stories. They may inspire wonder and a desire to linger longer under a fruiting tree or over a produce stand.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kathy Rodman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kathy studied art at The Art Institute of Chicago and English literature at UCLA. She traveled the world with her first husband and his band, and again with her second husband, a psychoanalyst and writer. These travels inspired her love of music, history, food, and languages. Binnie studied fine arts at Brooklyn College, where she discovered her passion for photography. Kathy and Binnie met at their daughters’ preschool. Widowed within a year of each other, they decided to cohabitate, create and travel about once again. So, when life handed them lemons, they made lemon marmalade.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0